import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, Home } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/context/AuthContext';

const NotFound = () => {
  const { user } = useAuth();
  // Pick a sensible "home" per role
  const home =
    user?.role === 'super_admin' ? '/super-admin/dashboard'
    : user?.role === 'org_admin'
      ? (user?.organization_id ? `/org-admin/${user.organization_id}/dashboard` : '/org-admin')
    : user?.role === 'user' ? '/dashboard'
    : '/login';

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 via-slate-50 to-gray-100 p-6">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center">
        <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-gradient-to-r from-orange-400 to-orange-600 flex items-center justify-center shadow-lg">
          <Shield className="w-8 h-8 text-white" />
        </div>
        <h1 className="text-5xl font-bold text-gray-800 font-sans mb-2">404</h1>
        <h2 className="text-lg font-semibold text-gray-700 font-sans mb-2">Página não encontrada</h2>
        <p className="text-sm text-gray-500 font-sans mb-6">
          O endereço acessado não existe ou foi movido.
        </p>
        <Link to={home}>
          <Button className="bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white font-semibold font-sans shadow-lg">
            <Home className="w-4 h-4 mr-2" />
            Voltar ao início
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
